import { useEffect, startTransition } from 'react';
import { useNavigate } from 'react-router';
import { useUserSession } from '../../contexts/UserSession';

const SignOutPage = () => {
    const navigate = useNavigate();
    const { signOut } = useUserSession();

    useEffect(() => {
        startTransition(() => {
            signOut();
        });
    }, [navigate, signOut]);

    return null;
};

export default SignOutPage;
